/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationMessage
 */
export interface NotificationMessage {
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    type: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof NotificationMessage
     */
    data?: { [key: string]: object; } | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    timestamp: string;
}

export function NotificationMessageFromJSON(json: any): NotificationMessage {
    return NotificationMessageFromJSONTyped(json, false);
}

export function NotificationMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'id': json['id'],
        'timestamp': json['timestamp'],
    };
}

export function NotificationMessageToJSON(value?: NotificationMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'data': value.data,
        'id': value.id,
        'timestamp': value.timestamp,
    };
}


